import { render, staticRenderFns } from "./CustomersLocationsManagementIndex.vue?vue&type=template&id=533c4e60&"
import script from "./CustomersLocationsManagementIndex.vue?vue&type=script&lang=js&"
export * from "./CustomersLocationsManagementIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomersLocationsManagementIndex.vue?vue&type=style&index=0&id=533c4e60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports